import { Factura } from '@/types/invoices/factura';

export const facturaTypes = {
  startLoadingFacturas: '[FACTURAS] Start Loading',
  finishLoadingFacturas: '[FACTURAS] Finish Loading',
  facturasLoad: '[FACTURAS] Load facturas',
};

interface StartLoadingFacturasAction {
  type: typeof facturaTypes.startLoadingFacturas;
  payload: null;
}

interface FinishLoadingFacturasAction {
  type: typeof facturaTypes.finishLoadingFacturas;
  payload: null;
}

interface FacturasLoadAction {
  type: typeof facturaTypes.facturasLoad;
  payload: Factura[];
}

export type FacturaActions = StartLoadingFacturasAction | FinishLoadingFacturasAction | FacturasLoadAction;
